import { render, staticRenderFns } from "./TruncatedCell.vue?vue&type=template&id=4280fd72&scoped=true"
import script from "./TruncatedCell.vue?vue&type=script&lang=js"
export * from "./TruncatedCell.vue?vue&type=script&lang=js"
import style0 from "./TruncatedCell.vue?vue&type=style&index=0&id=4280fd72&prod&scoped=true&lang=css"
import style1 from "./TruncatedCell.vue?vue&type=style&index=1&id=4280fd72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4280fd72",
  null
  
)

export default component.exports